<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >

            <van-divider>费用信息</van-divider>

            <van-cell-group>

                <van-cell
                        input-align="right"
                        title="报名费"
                        :value="row.order.memberprice"
                />
                <van-cell
                        input-align="right"
                        title="物料费"
                        :value="row.order.goodsprice"
                />
                <van-cell
                        input-align="right"
                        title="费用总计"
                        :value="row.order.total"
                />
                <van-cell
                        input-align="right"
                        title="已付"
                        :value="row.order.payed_price"
                />
                <van-cell
                        input-align="right"
                        title="还应付"
                        :value="row.order.total-row.order.payed_price"
                />

            </van-cell-group>

            <div class="savebtn-text">
                <div class="gray-light" style="margin-bottom: .2rem">支付后不能再添加考级人员</div>
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">立即支付</van-button>
            </div>
        </van-form>

        <PayDialog :show="payDialogShow" scene="qcxj_apply" :ids="orderIds" @onPayError="onPayError" @onPaySuccess="onPaySuccess"
                   @onPayClose="onPayClose"/>


    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .fapiao-tip-wrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        line-height: 36px;
        padding: 0.2rem;
        font-size: 14px;
        color: #666;
    }
    .savebtn-text {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        /*display: flex;*/
        /*flex: 1;*/
        /*flex-direction: row;*/
        /*justify-content: space-around;*/
      text-align: center;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import FamliyPicker from '@/components/picker/FamliyPicker.vue';

    import PayDialog from '@/components/PayDialog.vue';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'ExameApplyOrderMine',
        components: {
            [Field.name]: Field,
            PicUploader,
            PayDialog,
            FileUploader,
        },
        data: function () {
            return {
                validator,
                payDialogShow:false,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                subjectName:'',
                orderIds:[],
                subjectArray:[],
                subjectOptions:[],
                row:{
                    order:{
                        payed_price:0,
                    }
                },
            }
        },
        filters: {},
        mounted() {
            document.title="费用信息"
            let that = this;
            that.row.id = this.$route.query.id;
            if(that.row.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                }
                that.saveLoading = true;

                that.$api.post('/api/qcxj/applyordersave', that.row, (res) => {
                    that.saveLoading = false;

                    that.orderIds = res.data.ids;
                    that.payDialogShow = true;

                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/qcxj/applyorderdetail', {
                    id:that.row.id
                }, (res) => {
                  if(!res.data.order) {
                    Toast.fail('暂无订单相关信息')
                    return
                  }
                    that.row = res.data;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            },

            onPayError() {
                let that = this;
                console.log('onPayError 支付失败');
                that.payDialogShow = false;

                that.$toast('支付失败');

                rbLink({
                    name:'',
                },'back')

            },
            onPaySuccess() {
                let that = this;
                console.log('onPaySuccess 支付成功');
                that.payDialogShow = false;


                appEvent({
                    name: 'saiApplyDetailReload',
                    query: {
                    }
                });

                setTimeout(function () {
                    rbLink({
                        name:'ExameApplyListMine',
                      query: {
                        id: that.row.id
                      }
                    },'replace')

                },500);

            },
            onPayClose() {
                let that = this;
                console.log('onPayClose 支付关闭');
                that.payDialogShow = false;

                appEvent({
                    name: 'saiApplyDetailReload',
                    query: {
                    }
                });

                setTimeout(function () {
                    rbLink({
                        name:'',
                    },'back')

                },500);
            }


        }
    }
</script>



// WEBPACK FOOTER //
// ExameApplyOrderMine.vue?2be4a650